import { Grid } from 'semantic-ui-react'
import { useNavigate } from 'react-router-dom'

import TaxDeductionCard from '@/featuresV1/Dashboard/DashboardInsightsCards/TaxDeductionCard'
import TaxDeductionTipCard from '@/featuresV1/Dashboard/DashboardInsightsCards/TaxDeductionTipCard'
import { GridRowColumn, Text, Card, Alert, Button } from '@/base'
import { useReselector } from '@/utils/sharedHooks'
import { selectOnboardingStepCompletedOrSkipped } from '../../Onboarding/UserOnboardingSteps/onboarding.selectors'
import { GettingStartedOnboardingStep } from '../../Onboarding/UserOnboardingSteps/onboarding.reducer'
import { useAnalyticsTrack } from '@/featuresV1/Amplitude'

const MaximizeTaxDeductionsCard = () => {
  const navigate = useNavigate()
  const track = useAnalyticsTrack()

  const isUploadBankStatementsComplete = useReselector(
    selectOnboardingStepCompletedOrSkipped,
    GettingStartedOnboardingStep.uploadBankStatements
  )

  const shouldShowDataNotFinalAlert = !isUploadBankStatementsComplete

  const alertStyleProps = {
    type: 'warn' as const,
    fullWidth: true,
    style: {
      marginBottom: 24,
      marginTop: 24,
      marginLeft: 16,
      marginRight: 16,
    },
    innerTextStyle: {
      fontSize: 14,
    },
  }

  return (
    <Card type="section">
      <Grid>
        <GridRowColumn>
          <Text as="h2">Maximize Tax Deductions</Text>
        </GridRowColumn>

        {shouldShowDataNotFinalAlert && (
          <Alert {...alertStyleProps} title="Data pending">
            <div style={{ display: 'flex', gap: 16 }}>
              <Text as="bodySm" color="charcoal">
                We need your <strong>bank statements</strong> to provide an
                accurate view of your tax deductions. Upload your statements so
                we can complete your catch-up bookkeeping.
              </Text>
              <Button
                onClick={() => {
                  track('Maximize Tax Deductions - Upload Statements')
                  navigate('/practice/documents?tab=bank')
                }}
                variant="primary"
                size="small"
                style={{ whiteSpace: 'nowrap' }}
              >
                Upload Statements →
              </Button>
            </div>
          </Alert>
        )}

        <Grid.Row>
          <Grid.Column width={10}>
            <TaxDeductionCard />
          </Grid.Column>
          <Grid.Column width={6}>
            <TaxDeductionTipCard />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card>
  )
}

export default MaximizeTaxDeductionsCard
